<template>
  <a class="item ripple" href="#" @click.prevent="$emit('click')">
    <img :src="icono" :class="clase" class="img-bg" />
    <div>
      <div class="titulo">{{ titulo }}</div>
      <div class="subtitulo">{{ subtitulo }}</div>
      <div class="subindice">{{ subindice }}</div>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    icono: {
      type: String,
      required: true,
    },
    titulo: {
      type: String,
      required: true,
    },
    subtitulo: {
      type: String,
      required: false,
      default: null,
    },
    subindice: {
      type: String,
      required: false,
      default: null,
    },
    clase: {
      type: String,
      required: false,
      default: "poliza",
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  margin-bottom: 0.9rem;
}

.titulo {
  color: #ddd;
  font-weight: 500;
}

.subtitulo {
  color: lighten($azulClaroMMT, 20%);
}

.subindice {
  color: $naranjaMMT;
  font-size: 90%;
  animation: blinker 1s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}

.img-bg {
  margin-right: 10px;
  width: 2.5rem;
  /*background-color: darken($azulClaroMMT, 10%);*/
  border: 1px solid gray;
  border-radius: 50%;
}

.sini {
  background-color: $naranjaMMT;
  border: 1px solid $naranjaMMT !important;
}

a {
  text-decoration: none;
}
</style>
